<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <zj-layout-container class="header">
        <zj-layout-header>
          <div class="listtitle">任务下发</div>
        </zj-layout-header>
      </zj-layout-container>
      <zj-layout-container class="content">
        <el-form-item label="输入任务">
          <el-select
            :style="inlineItemStyle25"
            v-model="currenttaskvalue"
            v-on:change="currentTaskSelectChange"
            placeholder="选择任务"
          >
            <el-option
              v-for="item in tableData"
              :key="item.ExecutTaskId"
              :label="item.TaskTiltle"
              :value="item.ExecutTaskId"
            ></el-option>
          </el-select>
          <el-select
            :style="inlineItemStyle25"
            v-model="positionvalue"
            v-on:change="currentPositionSelectChange"
            placeholder="选择位置"
          >
            <el-option
              v-for="item in positions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="任务名称" prop="TaskTiltle">
          <el-input :style="inlineItemStyle80" v-model="ruleform.TaskTiltle"></el-input>
        </el-form-item>
        <el-form-item label="任务描述" prop="TaskDesc">
          <el-input :style="inlineItemStyle80" type="textarea" rows="2" v-model="ruleform.TaskDesc"></el-input>
        </el-form-item>
        <el-form-item label="任务地址" prop="Location">
          <el-input :style="inlineItemStyle50" v-model="ruleform.Location"></el-input>
        </el-form-item>
        <el-form-item label="计划响应时间" prop="PlanResponseTime">
          <el-input-number :min="0" v-model="ruleform.PlanResponseTime" controls-position="right"></el-input-number>
          <label>分钟</label>
        </el-form-item>
        <el-form-item label="经纬度">
          <el-input :style="inlineItemStyle25" v-model="ruleform.Longitude"></el-input>
          <el-input :style="inlineItemStyle25" v-model="ruleform.Latitude"></el-input>
          <ZjLngLatSelect
            class="newtaskposition"
            :point_lat="ruleform.Latitude"
            :point_lng="ruleform.Longitude"
            @onGotLngLat="onGotLngLat"
          ></ZjLngLatSelect>
        </el-form-item>
        <el-form-item label="负责人" prop="ChargerName">
          <el-input :style="inlineItemStyle50" v-model="ruleform.ChargerName"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="PhoneList">
          <div>任务会通过短信的形式发送给相关人员</div>
          <div
            :style="{ margin: '2px 0px'}"
            v-for="(item,index) in ruleform.PhoneList"
            :key="index"
          >
            <el-input
              :style="inlineItemStyle50"
              v-model="item.Phone"
            ></el-input>
            <el-button :style="{ 'background-color':'transparent'}" @click="addContact()">添加</el-button>
            <el-button
              :style="{ color:'#f04a4c', 'background-color':'transparent', 'border-color':'#f04a4c'}"
              @click="removeContact(index)"
            >删除</el-button>
          </div>
          <div>
            从应急通信录选择
            <i
              @click="isshow = !isshow"
              :class="isshow?'el-icon-arrow-up':'el-icon-arrow-down'"
            ></i>
          </div>
          <UserTabControl v-if="isshow" ref="userTabls" />
        </el-form-item>
      </zj-layout-container>
      <zj-layout-container class="footer">
        <el-form-item class="btns">
          <el-button @click="onBack()">返回</el-button>
          <el-button type="primary" @click="submitForm('ruleform')">提交</el-button>
        </el-form-item>
      </zj-layout-container>
    </el-form>
  </div>
</template>
<script>
import ZJApp from "../../../../../../app";
import Constant from "../config/constant";
import UserTabControl from "../../Plan/UserTabControl";
// eslint-disable-next-line no-unused-vars
import MyApis from "../../../../apis";

export default {
  name: "ZJEmergencyComponentNewTask",
  componentName: "ZJEmergencyComponentNewTask",
  components: {
    UserTabControl: UserTabControl
  },
  props: {
    ExecutId: {
      type: String,
      required: true
    },
    tableData: {
      type: Object,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {
      inlineItemStyle25: {
        width: "25%",
        "margin-right": "2rem"
      },
      inlineItemStyle50: {
        width: "50%",
        "margin-right": "2rem"
      },
      inlineItemStyle80: {
        width: "80%",
        "margin-right": "2rem"
      },
      isshow: false,
      positions: [
        { label: "之后插入", value: "1" },
        { label: "之前插入", value: "2" }
      ],
      ruleform: {
        Creater: ZJApp.ZJUser.current.UserName,
        CreateTime: new Date(),
        Modifier: ZJApp.ZJUser.current.UserName,
        ModifyTime: new Date(),
        Validity: 1,
        Extend1: "人工下发",
        OrgId: this.getOrgId(),
        ExecutTaskId: ZJApp.ZJUtils.uuid(),
        ExecutId: this.ExecutId,
        TaskTiltle: "",
        TaskDesc: "",
        ChargerId: "",
        ChargerName: "",
        Phone: "",
        PlanResponseTime: 0,
        ExecWay: "2", // 1:auto，2：manual
        PlanResourceId: "",
        OrderNo: 0,
        Memo: "",
        TaskStatus: Constant.TaskStatus.Todo.code,
        Location: "",
        Longitude: 0,
        Latitude: 0,
        ListReceiver: [],
        PhoneList: [{ Phone: "" }]
      },
      rules: {
        TaskTiltle: [
          { required: true, message: "请选择任务名称", trigger: "blur" }
        ],
        TaskDesc: [
          { required: true, message: "请填写任务描述", trigger: "blur" },
          {
            min: 0,
            max: 1000,
            message: "长度最长为1000个字符",
            trigger: "blur"
          }
        ],
        PhoneList: [
          {
            type: "array",
            required: true,
            validator: this.validphone,
            trigger: "blur"
          }
        ]
      },
      msgkey: "",
      currenttaskvalue: "",
      positionvalue: "",
      startTaskMsgKey: "MessageKey_EmergencyEventStartTask"
    };
  },
  methods: {
    validphone: function(rule, value, callback) {
      console.log("validphone");
      if (!value || value.length == 0) {
        callback(new Error("请输入电话号码"));
      } else if (!this.validphonelist(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    },
    validphonelist(arr) {
      var result = arr.every(function(item) {
        return ZJApp.ZJUtils.isRightMobileNum(item.Phone);
      });
      return result;
    },
    submitForm(formName) {
      let that = this;

      this.$refs[formName].validate().then(valid => {
        if (valid) {
          //插入反馈数据
          var newtask = that.getNewTask();
          new MyApis.ExecutTaskApi()
            .StartTaskManual(newtask)
            .then(r => {
              let data = r.data.Data;
              if (data) {
                var msgcontent = {
                  key: this.startTaskMsgKey,
                  data: newtask.ExecutTaskId
                };
                this.$notify.broadcase(msgcontent);
                that.$message({
                  message: r.RspMsg ? r.RspMsg : "下发任务成功！",
                  type: "success"
                });
                //关闭当前弹窗
                that.$emit("handlerclose");
              } else {
                that.$message({
                  message: r.RspMsg ? r.RspMsg : "下发任务失败！",
                  type: "error"
                });
              }
            })
            .catch(e => {
              console.error(e);
              that.$message({
                message: e.RspMsg ? e.RspMsg : "下发任务失败！",
                type: "error"
              });
            });
        }
      });
    },
    addContact() {
      this.ruleform.PhoneList.push({ Phone: "" });
    },
    removeContact(index) {
      if (this.ruleform.PhoneList.length > 1) {
        this.ruleform.PhoneList.splice(index, 1);
      }
    },
    onBack: function() {
      this.$emit("handlerclose");
    },
    getOrgId: function() {
      let deptId =
        ZJApp.ZJUser.current.Departments.length > 0
          ? ZJApp.ZJUser.current.Departments[0].OrgId
          : "error-no-department";
      return deptId;
    },
    onGotLngLat(obj) {
      this.ruleform.Latitude = obj.lat || 0;
      this.ruleform.Longitude = obj.lng || 0;
    },
    getUserIds() {
      let userids = [];
      var chil = this.$refs["userTabls"];
      if(chil && chil.GetOrgUserIds)
      {
         userids = chil.GetOrgUserIds();
      }
      return userids;
    },
    getNewTask() {
      var task = this.ruleform;

      var userids = this.getUserIds();
      if (userids) {
        for (let i = 0; i < userids.length; i++) {
          if (userids[i]) {
            task.ListReceiver.push({
              Creater: ZJApp.ZJUser.current.UserName,
              //CreateTime :  new Date(),
              Modifier: ZJApp.ZJUser.current.UserName,
              //ModifyTime :  new Date(),
              Validity: 1,
              //Extend1: userids[i],
              OrgId: this.getOrgId(),
              ExecutId: this.ExecutId,
              ExecutReceiverId: ZJApp.ZJUtils.uuid(),
              ReceiverId: userids[i]
            });
          }
        }
      }

      for (let i = 0; i < this.ruleform.PhoneList.length; i++) {
        if (this.ruleform.PhoneList[i].Phone) {
          task.ListReceiver.push({
            Creater: ZJApp.ZJUser.current.UserName,
            //CreateTime :  new Date(),
            Modifier: ZJApp.ZJUser.current.UserName,
            //ModifyTime :  new Date(),
            Validity: 1,
            Extend1: this.ruleform.PhoneList[i].Phone,
            OrgId: this.getOrgId(),
            ExecutId: this.ExecutId,
            ExecutReceiverId: ZJApp.ZJUtils.uuid()
          });
        }
      }
      return task;
    },
    currentTaskSelectChange(value) {
      console.log(value);
    },
    currentPositionSelectChange(value) {
      console.log(value);
    }
  }
};
</script>